import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectModel } from 'src/tidy-ui-components/components/form/select/select.model';
import * as moment from 'moment';

@Injectable()
export class StaticData {

  timeRanges(): Array<SelectModel> {
    const ranges = [
      {viewValue: '12:00am', value: '00:00'},
      {viewValue: '12:30am', value: '00:30'},
      {viewValue: '1:00am', value: '01:00'},
      {viewValue: '1:30am', value: '01:30'},
      {viewValue: '2:00am', value: '02:00'},
      {viewValue: '2:30am', value: '02:30'},
      {viewValue: '3:00am', value: '03:00'},
      {viewValue: '3:30am', value: '03:30'},
      {viewValue: '4:00am', value: '04:00'},
      {viewValue: '4:30am', value: '04:30'},
      {viewValue: '5:00am', value: '05:00'},
      {viewValue: '5:30am', value: '05:30'},
      {viewValue: '6:00am', value: '06:00'},
      {viewValue: '6:30am', value: '06:30'},
      {viewValue: '7:00am', value: '07:00'},
      {viewValue: '7:30am', value: '07:30'},
      {viewValue: '8:00am', value: '08:00'},
      {viewValue: '8:30am', value: '08:30'},
      {viewValue: '9:00am', value: '09:00'},
      {viewValue: '9:30am', value: '09:30'},
      {viewValue: '10:00am', value: '10:00'},
      {viewValue: '10:30am', value: '10:30'},
      {viewValue: '11:00am', value: '11:00'},
      {viewValue: '11:30am', value: '11:30'},
      {viewValue: '12:00pm', value: '12:00'},
      {viewValue: '12:30pm', value: '12:30'},
      {viewValue: '1:00pm', value: '13:00'},
      {viewValue: '1:30pm', value: '13:30'},
      {viewValue: '2:00pm', value: '14:00'},
      {viewValue: '2:30pm', value: '14:30'},
      {viewValue: '3:00pm', value: '15:00'},
      {viewValue: '3:30pm', value: '15:30'},
      {viewValue: '4:00pm', value: '16:00'},
      {viewValue: '4:30pm', value: '16:30'},
      {viewValue: '5:00pm', value: '17:00'},
      {viewValue: '5:30pm', value: '17:30'},
      {viewValue: '6:00pm', value: '18:00'},
      {viewValue: '6:30pm', value: '18:30'},
      {viewValue: '7:00pm', value: '19:00'},
      {viewValue: '7:30pm', value: '19:30'},
      {viewValue: '8:00pm', value: '20:00'},
      {viewValue: '8:30pm', value: '20:30'},
      {viewValue: '9:00pm', value: '21:00'},
      {viewValue: '9:30pm', value: '21:30'},
      {viewValue: '10:00pm', value: '22:00'},
      {viewValue: '10:30pm', value: '22:30'},
      {viewValue: '11:00pm', value: '23:00'},
      {viewValue: '11:30pm', value: '23:30'}
    ];
    return this.translateAMPM(ranges) as Array<SelectModel>;
  }

  translateAMPM(formattedTime: string | Array<SelectModel>): string | Array<SelectModel> {
    const language = localStorage.getItem('language') || 'en';
    if (typeof formattedTime === 'string') {
      let result = formattedTime;
      Object.keys(translations).forEach(key => {
        if (translations[key][language] && result.includes(key)) {
          result = result.replace(key, translations[key][language]);
        }
      });
      return result;
    } else {
      return formattedTime.map(item => ({
        ...item,
        viewValue: Object.keys(translations).reduce((text, key) => {
          if (translations[key][language] && text.includes(key)) {
            return text.replace(key, translations[key][language]);
          }
          return text;
        }, item.viewValue)
      }));
    }
  }

  selectedTimesText(timeBlocks: Array<{start_time: string, end_time: string}>): string {
    return timeBlocks.reduce((prev, curr) => {
      return `${prev}${prev ? ', ' : ''}${this.formatMilitaryTime(curr.start_time)}-${this.formatMilitaryTime(curr.end_time)}`;
    },'');
  }

  formatMilitaryTime(militaryTime) {
    return moment(militaryTime, 'HH:mm').format('hh:mma');
  }

  buildWeekDays(): Array<any> {
    return [
      { day: 'Monday', availability: [] },
      { day: 'Tuesday', availability: [] },
      { day: 'Wednesday', availability: [] },
      { day: 'Thursday', availability: [] },
      { day: 'Friday', availability: [] },
      { day: 'Saturday', availability: [] },
      { day: 'Sunday', availability: [] }
    ];
  }

}

const translations = {
  'am': {
    en: 'am',
    es: 'am',
    ar: 'ص',
    fr: 'am',
    pt: 'am',
    de: 'am',
    ja: 'am',
    it: 'am'
  },
  'pm': {
    en: 'pm',
    es: 'pm',
    ar: 'م',
    fr: 'pm',
    pt: 'pm',
    de: 'pm',
    ja: 'pm',
    it: 'pm'
  }
};
